module.exports = __webpack_public_path__ + "img/Brick Plaza Rendering _ Feb.f98b1de9.jpeg";